export default __webpack_public_path__ + "assets/images/17e979918896e72e0210380dce765052.jpeg";